import { EY_TEMPLATES } from "./constants";

export const isEY = (templateKey) => EY_TEMPLATES.includes(templateKey);
